module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bdbc96c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 502
// module chunks = 1